const randomWalk = (points, startPrice, volatility = 0.018) => {
  const closes = [startPrice];
  for (let i = 1; i < points; i += 1) {
    const drift = (Math.random() - 0.48) * volatility;
    closes.push(Math.max(1, closes[i - 1] * (1 + drift)));
  }
  return closes;
};

const buildOhlc = (closes) =>
  closes.map((close, i) => {
    const prev = closes[i - 1] ?? close;
    const open = i === 0 ? close : prev;
    const wick = close * (0.004 + Math.random() * 0.012);
    const high = Math.max(open, close) + wick;
    const low = Math.min(open, close) - wick;
    return [open, close, low, high].map((v) => Number(v.toFixed(2)));
  });

const formatLabels = (points, range) => {
  const now = Date.now();
  const step =
    range === '1D' ? 5 * 60 * 1000 : range === '1W' ? 60 * 60 * 1000 : 4 * 60 * 60 * 1000;

  return Array.from({ length: points }, (_, i) => {
    const d = new Date(now - (points - 1 - i) * step);
    if (range === '1D') {
      return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  });
};

export const RANGE_CONFIG = {
  '1D': { points: 78, base: 42 },
  '1W': { points: 42, base: 38 },
  '1M': { points: 30, base: 35 },
};

export const generateDemoStockSeries = (seed = 1, range = '1D') => {
  const { points, base } = RANGE_CONFIG[range] || RANGE_CONFIG['1D'];
  const startPrice = 28 + (seed % 17) + base * 0.4;
  const closes = randomWalk(points, startPrice);
  const ohlc = buildOhlc(closes);
  const labels = formatLabels(points, range);

  const last = closes[closes.length - 1];
  const first = closes[0];
  const change = last - first;
  const changePct = (change / first) * 100;

  return {
    labels,
    ohlc,
    closes,
    quote: {
      price: Number(last.toFixed(2)),
      change: Number(change.toFixed(2)),
      changePct: Number(changePct.toFixed(2)),
      high: Number(Math.max(...closes).toFixed(2)),
      low: Number(Math.min(...closes).toFixed(2)),
      volume: Math.floor(12000 + seed * 137 + closes.length * 890),
    },
  };
};

export const tickerFromArtwork = (artwork, slug) => {
  if (artwork?.artID) {
    return `ART-${String(artwork.artID).replace(/-/g, '').slice(0, 6).toUpperCase()}`;
  }
  if (slug) {
    return `ART-${slug.replace(/[^a-z0-9]/gi, '').slice(0, 6).toUpperCase() || 'WORK'}`;
  }
  return 'ART-DEMO';
};
